// extracted by mini-css-extract-plugin
export var mediaPlayer = "YoutubePlayer-module--media-player--f81f2";
export var modal = "YoutubePlayer-module--modal--7b790";
export var video = "YoutubePlayer-module--video--e1f20";
export var buttonPause = "YoutubePlayer-module--button-pause--57503";